import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'concatAddress',

    // WARN: Use with caution!
    // Use this if the pipe should be called on value changed.
    // pure: false,
})
export class ConcatAddressPipe implements PipeTransform {
    public transform(parts: string[], joinChar: string = ' '): string {
        return parts
            .map(part => part?.trim())
            .filter(Boolean)
            .map((part, index) => {
            // Append a comma only if it's not the last part and doesn't already end with a comma
            return part + ((index < parts.length - 1 && !part.endsWith(',')) ? ',' : '');
        }).join(joinChar);
    }
}
